import React from 'react';
import utilWithoutAuth from "../../../util/toolsWithoutAuth";
import commonTools from "../../../../common/util/util";
import P from "prop-types";
import Timer from '../timer'
import './index.css';
import { Modal,Button } from "antd-mobile"
const antdAlert = Modal.alert;

export default class getMoneyNew extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };
    
    constructor(props) {
        super(props);
        this.state = {
            downloadUrl:"",
            timer:false,
            curTitle: "免费趣小说",
            money: 0,
            code: "",
            ewmImgUrl: require("../../../images/ewmBg.png") || "",
            userInfo:{},
            isiOS:undefined,
        };
        this.state.isAndroid = this.getNavigator().isAndroid
        this.state.isiOS = this.getNavigator().isiOS
        this.goFun = this.goFun.bind(this);
        this.getMoney = this.getMoney.bind(this);
    }

    getNavigator = () => {
        if(global.navigator && global.navigator.userAgent){
            const u = global.navigator.userAgent;
            const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if(!isiOS){
                let dom = document.getElementById("normal")
                dom.style.display = "inherit"
            }
            return {
                isAndroid,
                isiOS,
            }
        }else{
            return {isAndroid:false,isiOS:false}
        }
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        let navigatorObj = this.getNavigator()
        this.setState(navigatorObj)
        let money = commonTools.searchPar().redpack_amount
        this.setState({
            money
        })
        
        try{
            localStorage.setItem("turl",document.location.href);
        }catch(e){}

        // this.getMoney();
        this.getUserInfo()

        utilWithoutAuth.ajax({
            url: "/zh/attentionuser/QRCodeUrl",
            method:'post',
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        ewmImgUrl: res.result.data.url
                    });
                }
            }
        });
    }

    getMoney(){
        utilWithoutAuth.ajax({
            host: "//open.kxxsc.com",
            app_key: "6529624231",
            app_secret: "aedddf6bc6c4aba9d317efb843d6eb29",
            app_token: 1,
            url: "/app/quxiaoshuo/share/request_red_packet",
            data: {
                sn: commonTools.searchPar().sn,
                user_id: commonTools.searchPar().user_id,
                app_id: commonTools.searchPar().app_id,
                open_id: utilWithoutAuth.open_id,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    this.setState({
                        money: json.amount/100,
                    });
                }else{
                    alert(res.result.status.msg);
                }
            }
        });
    }

    getUserInfo(){
        utilWithoutAuth.ajax({
            host: "//open.kxxsc.com",
            app_key: "6529624231",
            app_secret: "aedddf6bc6c4aba9d317efb843d6eb29",
            app_token: 1,
            url: "/app/quxiaoshuo/users/simple_user_info",
            data: {
                user_id: commonTools.searchPar().user_id,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    this.setState({
                        userInfo: json
                    });
                }else{
                    alert(res.result.status.msg);
                }
            }
        });
    }

    goFun(){
        // if(!this.state.code){
        //     return false;
        // }
        let phoneNum = this.inputRef.value;
        if(phoneNum.length != 11){
            alert("请正确填写十一位手机号");
            return false;
        }
        let code = this.state.code
        utilWithoutAuth.ajax({
            host: "//open.kxxsc.com",
            app_key: "6529624231",
            app_secret: "aedddf6bc6c4aba9d317efb843d6eb29",
            app_token: 1,
            url: "/app/quxiaoshuo/v300/invite_friends/phone",
            data: {
                app_id: commonTools.searchPar().app_id,
                user_id: commonTools.searchPar().user_id,
                version_name:commonTools.searchPar().version_name,
                phone:phoneNum,
                code,
                // leeCode:code,
                // open_id: util.open_id,
                // mobile: phoneNum
            },
            callback: res => {
                console.log("这是res",res)
                if (res.result.status.code == 0) {
                    if(res && res.result && res.result.data && res.result.data.app_download_url){
                        this.setDownloadUrl(res.result.data.app_download_url)
                    }
                    // try{
                    //     window.bridge.jump(`client://kanshu/receive_money?phone=${phoneNum}&share_type=${commonTools.searchPar().share_type}&user_id=${commonTools.searchPar().user_id}`);
                    // }catch(e){
                    //     document.location.href = `//activity.read2.cn/quxiaoshuo/down?phone=${phoneNum}&share_type=${commonTools.searchPar().share_type}&user_id=${commonTools.searchPar().user_id}`;
                    //     // this.props.history.push(`/quxiaoshuo/down?phone=${phoneNum}&share_type=${commonTools.searchPar().share_type}&user_id=${commonTools.searchPar().user_id}`);
                    // }
                }else{
                    alert(res.result.status.msg);
                }
            }
        });
    }

    setDownloadUrl = (downloadUrl) => {
        this.setState({
            downloadUrl
        })
    }

    changeCode = (e) => {
        this.setState({
            code:e.target.value,
        })
    }

    getCode = () => {
        //禁用状态
        if(this.state.timer === false){
            //手机号校验
            let phoneNum = this.inputRef.value;
            if(phoneNum.length != 11){
                alert("请正确填写十一位手机号");
                return false;
            }
            this.setState({
                timer:true
            })
            utilWithoutAuth.ajax({
                host: "//open.kxxsc.com",
                method:'post',
                url: "/app/quxiaoshuo/phone/sendmsg",
                isUser: true,
                data: {
                    'phone': phoneNum+"",
                    app_id:"18630930",//免费趣小说
                    version_name:commonTools.searchPar().version_name,
                },
                crossOrigin:true,
                callback: res => {
                    if (res.result.status.code != 0) {
                        this.refs.timer.stop()
                        if(res.result.status.code == "72004"){
                           this.alreadyGet()
                            return
                        }
                        alert(res.result.status.msg)
                    }
                }
            });
        }
    }

    alreadyGet = () => {
        this.antdAlert = antdAlert(<span style={{position:"relative",display:"inline-block",width:"100%"}}>
            您已领取过红包
            <span onClick={this.closeAntdAlert} style={{position:"absolute",top:"-12px",right:"-3px"}}>x</span></span>, '是否打开app查看', [
            { text: <span style={{color:"#999"}}>换个号码</span>, onPress: () => {this.inputRef.value = ""}, style: 'default' },
            { text: <span style={{color:"#e97929"}}>立即查看</span>, onPress: this.onCheck },
        ]);
    }

    closeAntdAlert = () => {
        this.inputRef.value = ""
        this.antdAlert.close();
    }

    onCheck = () => {
        console.log("立即查看")
        this.download()
    }

    download(){
        const downloadUrl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.kanshu.fun.novel"
        const clientUrl = "client://kanshu/main"
        console.log(window)
        window.location.href = clientUrl;
        if(!document.hidden){
            window.setTimeout(function(){
                if(!document.hidden){
                    //qq的浏览器阻止了window.open
                    window.location.href=downloadUrl
                }
            },2000);

        }

    }

    timeReset = () => {
        this.setState({
            timer:false
        })
    }

    fixMoney = (str) => {
        return Number(str)*0.01
    }

    goTop = () => {
        //解决ios端底部留白的兼容性问题
        window.scrollTo(0,0)
    }

    check = () => {
        let phoneNum = this.inputRef.value;
        if(phoneNum.length != 11){
            return false;
        }
        console.log("检测手机号是否被注册：",phoneNum)
    }

    bank = () => {
        //只考虑apk打开的清空
        if(window && window.bridge && window.bridge.exit){
            window.bridge.exit()
        }
        setTimeout(()=>{
            window.history.back();
        },500)
    }

    renderIos = () => {
        return <div className='quxiaoshuoHome quxiaoshuo_bg3'></div>
    }

    renderNormal = () => {
        let { nickname ,headimgurl } = this.state.userInfo
        return (
            <span id="normal" style={{display:"none"}}>
                {
                    this.state.downloadUrl ? (
                        <div className='quxiaoshuoHome quxiaoshuo_bg2'>
                            <div style={{position:"absolute",top:"1.65rem",fontSize:"0.56rem",width:"100%",color:"#fff"}}>
                            <span style={{textAlign:"center"}}>
                                <b>
                                您有<span>{this.fixMoney(this.state.money)+"元"}</span>红包待提现
                                </b>
                            </span>
                            </div>
                            <div style={{position:"absolute",top:"4.2rem",fontSize:"0.46rem",width:"100%",color:"#333"}}>
                            <span style={{textAlign:"center"}}>
                                <b>
                                    <span style={{color:"red",fontSize:"0.86rem"}}>{this.fixMoney(this.state.money)}</span>元
                                </b>
                            </span>
                            </div>
                            <div style={{position:"absolute",top:"7.1rem",left:"1.1rem"}}>
                                <div style={{display:"inline-block",width:"1.05rem",margin:"0rem 0.1rem"}}>
                                    <img src={require("../../../../common/images/quxiaoshuoicon.png")} style={{width:"1.05rem",height:"1.05rem",position:"relative"}} />
                                </div>
                                <div style={{display:"inline-block",position:"relative",color:"#333",
                                    left:"0.1rem",top:"-0.7rem",fontSize:"0.32rem"
                                }}>
                                    <p>免费趣小说,白拿钱！</p>
                                </div>
                            </div>
                            <div style={{top:"9.5rem",background:"#ef8d35",color:"#fff",width:"5.4rem",lineHeight:"0.88rem",fontSize:"0.32rem"}} className='getBtn' onClick={this.download} >
                                立即下载
                            </div>
                        </div>
                    ) : (
                        <div className='quxiaoshuoHome quxiaoshuo_bg1'>
                            <div className='title1' style={{marginTop:"2.65rem"}}>
                                <img src={headimgurl || "http://img2.imgtn.bdimg.com/it/u=1409224092,1124266154&fm=26&gp=0.jpg"}
                                     style={{width:"1.0rem",height:"1.0rem",borderRadius:"0.5rem"}}/>
                            </div>
                            <div className='title2' style={{margin:"0rem 0.6rem 0rem",color:"#999",height:"0.5rem",fontSize:"0.3rem",background:"#fff"}}>{nickname}送你</div>
                            <div className='title3' style={{margin:"0.15rem 0.6rem 0rem",color:"#000",height:"0.7rem",fontSize:"0.44rem",background:"#fff"}}>
                                <b>
                                    新人
                                    <span style={{color:"#eb5e57"}}>{this.fixMoney(this.state.money)+"元"}</span>
                                    现金红包
                                </b>
                            </div>
                            {/*<div className="ewmBox">*/}
                            {/*<Img className="ewmBg" src={require("../../../images/ewmBg.png")} />*/}
                            {/*{!!this.state.ewmImgUrl && <Img className="ewmImg" src={this.state.ewmImgUrl} />}*/}
                            {/*</div>*/}
                            <input style={{top:"6.8rem",width:"6.0rem",background:"#fff",fontSize:"0.3rem",lineHeight:"1.5em",
                                textAlign:"left",paddingLeft:"0.55rem"}} pattern="[0-9]*" onBlur={()=>{this.goTop;this.check()}}
                                   type="number" className="inputTxt" ref={node=>this.inputRef=node} placeholder="请输入手机号码" />
                            <input style={{top:"8.0rem",width:"6.0rem",background:"#fff",fontSize:"0.3rem",lineHeight:"1.5em",textAlign:"left",paddingLeft:"0.55rem"}}
                                   className="inputTxt1" onChange={this.changeCode} onBlur={this.goTop}/>
                            <span style={{top:"8.2rem",height:"0.5rem"}} className="input-click" onClick={this.getCode}>
                        {
                            !this.state.timer ? <span style={{color:"#ef8d35",borderLeft:"2px solid #d8d8d8",paddingLeft:"0.5rem"}}>获取验证码</span> : null
                        }
                                <Timer ref="timer" tag={this.state.timer} time={60} reset={this.timeReset}/>
                        </span>
                            <div style={{top:"9.4rem",background:"#ef8d35",color:"#fff",width:"6.0rem"}} className='getBtn' onClick={this.goFun}>点击领取</div>
                            <span style={{top:"10.6rem",color:"red"}} className="details">
                            活动仅限首次注册新用户
                        </span>
                        </div>
                    )
                }
            </span>
        )
    }

    render() {
        let { isiOS } = this.state
        return (
            <div>
                {
                    isiOS===undefined ? null :(isiOS ? this.renderIos() :this.renderNormal())
                }
            </div>
        );
    }
}